var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSyfat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.65 47.118a4.887 4.887 0 10.164-9.77h-.68c-6.953-.73-12.371-6.61-12.371-13.755 0-7.638 6.192-13.83 13.83-13.83 7.639 0 13.83 6.192 13.83 13.83h9.763C47.186 10.563 36.623 0 23.593 0S0 10.563 0 23.593c0 12.714 10.057 23.08 22.65 23.575v-.05zm-4.03-26.81c-.688 0-1.246.76-1.246 1.699 0 .938.558 1.699 1.246 1.699h13.364c.689 0 1.247-.761 1.247-1.7 0-.938-.558-1.698-1.247-1.698H18.62zm-3.85 7.384c0-1.02.617-1.846 1.378-1.846h14.781c.761 0 1.379.827 1.379 1.846 0 1.02-.618 1.846-1.379 1.846H16.148c-.761 0-1.379-.826-1.379-1.846z",
    fill: "currentColor"
  })));
}
export default SvgSyfat;